import { FC, HTMLAttributes } from "react";
import { useStyles } from "./ProfileStats.styles";
import { StatCard, StatCardLoading } from "../StatCard";
import GZIcon from "../../../assets/icon/gamezone_coin/gamezone_coin_1x.webp";
import GZIcon2x from "../../../assets/icon/gamezone_coin/gamezone_coin_2x.webp";
import GZIcon3x from "../../../assets/icon/gamezone_coin/gamezone_coin_3x.webp";
import DailyStreakIcon from "../../../assets/icon/daily_streak/daily_streak_1x.webp";
import DailyStreakIcon2x from "../../../assets/icon/daily_streak/daily_streak_2x.webp";
import DailyStreakIcon3x from "../../../assets/icon/daily_streak/daily_streak_3x.webp";
import { CoinType, CoinWallet, User } from "@onmo/graphql/graphql";
import { useTranslation } from "react-i18next";

interface IProfileStatsProps {
  profile?: User;
  wallet?: Array<CoinWallet>;
}
export const ProfileStats: FC<
  HTMLAttributes<HTMLDivElement> & IProfileStatsProps
> = ({ profile, wallet }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  if (!profile)
    return (
      <div className={classes.root}>
        {Array.from(new Array(6)).map((_, idx) => (
          <StatCardLoading key={idx} />
        ))}
      </div>
    );

  const getGZCoins = () => {
    return (
      wallet?.find((wal) => wal.itemType === CoinType.GzTokens)?.balance || 0
    );
  };

  // changes needed as per backend changes....
  return (
    <div className={classes.root}>
      <StatCard
        statName={t("common_Coins balance")}
        statContent={getGZCoins()}
        icons={{ src: GZIcon, src2x: GZIcon2x, src3x: GZIcon3x }}
      />
      <StatCard
        statName={t("common_Daily Streak")}
        statContent={profile?.loginStreak}
        icons={{
          src: DailyStreakIcon,
          src2x: DailyStreakIcon2x,
          src3x: DailyStreakIcon3x,
        }}
      />
    </div>
  );
};
